import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MapModalComponent } from './map-modal/map-modal.component';
import { LocationPickerComponent } from './pickers/location-picker/location-picker.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { AngularCropperjsModule } from 'angular-cropperjs';
import { FormsModule } from '@angular/forms';
import { CommentsModalComponent } from './comments-modal/comments-modal.component';
import { PostCardComponent } from './post-card/post-card.component';
import { EditCaptionModalComponent } from './post-card/edit-caption-modal/edit-caption-modal.component';
import { PhoneCodesComponent } from './phone-codes/phone-codes.component';
import { CaseCardComponent } from './case-card/case-card.component';
import { AuthPopupComponent } from './auth-popup/auth-popup.component';
import { ImagePickerComponent } from './pickers/image-picker/image-picker.component';
import { OTPComponent } from './otp/otp.component';
import { UserOptionsComponent } from './user-options/user-options.component';
import { ImageViewerComponent } from './pickers/image-viewer.component';
@NgModule({
  declarations: [
    ImagePickerComponent,
    LocationPickerComponent,
    MapModalComponent,
    ImageCropperComponent,
    CommentsModalComponent,
    PostCardComponent,
    EditCaptionModalComponent,
    PhoneCodesComponent,
    CaseCardComponent,
    AuthPopupComponent,
    OTPComponent,
    UserOptionsComponent,
    ImageViewerComponent
  ],
  exports: [
    LocationPickerComponent,
    ImagePickerComponent,
    MapModalComponent,
    PostCardComponent,
    CaseCardComponent,
    EditCaptionModalComponent,
    AuthPopupComponent,
    OTPComponent,
    UserOptionsComponent, ImageViewerComponent

  ],
  imports: [
    CommonModule,
    IonicModule.forRoot(),
    AngularCropperjsModule,
    FormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
